import Properties from "../../../../../properties";
import { handleMessage } from "../../../utils";

export const CADASTRO_MESSAGES_PREFIX =
  "interface.registrar.identificacao.cadastro.";

const CADASTRO = {
  cadastro: {
    labels: {
      estrangeiro: ["Estrangeiro", "Foreigh"],
      cpf: ["CPF:", "CPF:"],
      nome: ["Nome:", "Name:"],
      passaporte: ["Passaporte:", "Passport:"],
      sexo: ["Sexo:", "Sex:"],
      dataNascimento: ["Data de nascimento:", "Date of birth:"],
      nomeMae: ["Nome da mãe:", "Mother's name:"],
      zonaLocalizacao: ["Zona de localização:", "Location zone:"],
      logradouro: ["Logradouro:", "Public place:"],
      bairro: ["Bairro:", "Neighborhood:"],
      numero: ["Número:", "Number:"],
      complemento: ["Complemento:", "Complement:"],
      cep: ["CEP:", "Postal code:"],
      municipio: ["Município:", "County:"],
      uf: ["UF:", "UF:"],
      email: ["E-mail:", "Email:"],
      confirmarEmail: ["Confirmar e-mail:", "Confirm email:"],
      descricaoAcesso: ["Descrição de acesso:", "Access description:"],
      semNumero: ["Sem número", "No number"],
      nacionalidade: ["Nacionalidade:", "Nationality:"],
      descricaoEndereco: ["Descrição do endereço:", "Address description:"],
      descricaoEndereco2: ["Complemento do endereço:", "Address complement:"],
      cidade: ["Cidade:", "City:"],
      estado: ["Estado/Província:", "State/Province:"],
      pais: ["País:", "Country:"],
      senha: ["Senha:", "Password:"],
      confirmarSenha: ["Confirmar Senha:", "Confirm Password:"]
    },
    dados: {
      genero: {
        masculino: ["Masculino", "Male"],
        feminino: ["Feminino", "Female"],
        outros: ["Outros", "Others"]
      },
      zonaLocalizacao: {
        urbana: ["Urbana", "Urban"],
        rural: ["Rural", "Rural"]
      }
    },
    titulos: {
      dadosPessoais: ["Dados pessoais", "Personal data"],
      dadosContato: ["Dados de contato", "Contact data"],
      enderecoEstrangeiro: ["Endereço de origem", "Origin Address"],
      enderecoPrincipal: ["Dados de endereço", "Address data"],
      enderecoCorrespondencia: [
        "Endereço de correspondência",
        "Mailing address"
      ],
      cadastroUsuario: ["Cadastro de Usuário", "User Registration"],
      seguranca: ["Segurança", "Security"]
    },
    botoes: {
      salvar: ["Salvar", "Save"],
      cancelar: ["Cancelar", "Cancel"]
    },
    mensagens: {
      sucesso: {
        titulo: ["Sucesso", "Success"],
        mensagem: [
          "Cadastro realizado com sucesso!",
          "Registration successful!"
        ]
      },
      sucessoConfirmacao: {
        titulo: ["Cadastro realizado", "Registration completed"],
        descricao: [
          "Enviamos um e-mail de confirmação para o endereço informado. Acesse o link no e-mail para ativar sua conta e, em seguida, faça login no sistema.",
          "We sent a confirmation email to the address you provided. Open the link in the email to activate your account, then sign in."
        ],
        redirecionamentoEm: [
          "Redirecionando para o login em {0} segundos.",
          "Redirecting to login in {0} seconds."
        ],
        irLoginComContagem: ["Ir para o login ({0}s)", "Go to login ({0}s)"]
      },
      erro: {
        titulo: ["Erro", "Error"],
        mensagem: ["Erro ao realizar cadastro.", "Error registering user."]
      },
      atencao: {
        titulo: ["Atenção", "Warning"],
        mensagem: [
          "Por favor, preencha todos os campos obrigatórios.",
          "Please fill in all required fields."
        ]
      },
      validacao: {
        titulo: ["Aviso", "Notice"],
        resumoVarios: [
          "Há pendências no formulário. Confira os campos indicados.",
          "There are issues in the form. Please check the highlighted fields."
        ]
      },
      paisesIndisponiveis: {
        titulo: ["Erro", "Error"],
        mensagem: [
          "Não foi possível carregar a lista de países. Tente novamente mais tarde.",
          "Could not load the list of countries. Please try again later."
        ]
      }
    },
    format: {
      data: ["dd/MM/yyyy", "yyyy-MM-dd"]
    },
    placeholders: {
      select: {
        geral: ["Selecione", "Select"],
        sexo: ["Selecione o sexo", "Select the sex"]
      }
    }
  }
};

export const EN_CADASTRO = handleMessage(
  CADASTRO,
  Properties.LANGUAGE_INDEX.EN
);
export const PT_CADASTRO = handleMessage(
  CADASTRO,
  Properties.LANGUAGE_INDEX.PT_BR
);
